/**
 * push new value to tracking
 *
 * @param string key
 * @param object value
 */
export const pushTrackingObject = (key: string, value: object) => {
    // @ts-ignore
    window._ddq.push([key, value]);

    /*// @ts-ignore
    const vf = typeof (window.VF) !== 'object' ? {} : window.VF;
    vf.tealiumEnvironment = 'autotest'; */
};
